import React from 'react'
import { useVocabulary } from '../context/vocabulary'
import { LookupItemPicker, LookupItemPickerUserPropsType } from './LookupItemPicker'

export const DestinationPicker = (props: Omit<LookupItemPickerUserPropsType, 'lookupItems'>) => {

  const { vocabulary } = useVocabulary()
  const allDestinationsItems = vocabulary.destinations

  return (
    <LookupItemPicker
      lookupItems={allDestinationsItems}
      {...props}
    />
  )
}
